import React, { Fragment } from "react";
import renderSaveButton from "./renderSaveButton";
import renderActionButton from "../SimpleForm/ActionButton";
import Button from "../SimpleForm/UI/Button";
import SubmitConfirmationModal from "./renderSubmitConfirmModal";

const getHelpLink = {
  position: "fixed",
  right: "20px",
  bottom: "15px",
  fontSize: "14px",
  padding: "13px 20px",
  borderRadius: "20px",
  backgroundColor: "rgba(236, 247, 255, 0.68)",
  margin: "0",
  color: "#727272",
};

const helpHref = {
  borderBottom: "1px solid #005ea2",
  // 'font-weight': 'bold',
  color: "#005ea2",
};

const modalInnerShell = {
  position: "relative",
};

const renderFormActions =
  (
    mutation,
    dataprop_name,
    application_id,
    cleanData,
    history,
    formSubmitting,
    hasSubmitConfirmation = false
  ) =>
  (
    isLastPage,
    page,
    invalid,
    submitting,
    next,
    previous,
    quit,
    values,
    form_ui,
    form_ui_name,
    canSubmit,
    submit,
    tablePagesErrors,
    isLocked
  ) => {
    const submitButton = {
      onClick: (e) => {
        // This is to prevent the "Case already submitted" error that is
        // caused by the user double clicking the submit button before it becomes disabled.
        // e.detail counts how many times the button is clicked.
        if (e.detail > 1) {
          return;
        }

        // submit button
        // there is a condition between submit() and btn.setAttribute('disabled', 'disabled')
        // if submit() is decided by the browser to fire first it will skip btn.setAttribute
        // adding a timeout isn't recommended but in this case it makes sense
        // it's a way of making sure btn.setAttribute gets fired first before submit()
        e.target.setAttribute("disabled", "disabled");
        setTimeout(function () {
          submit();
        }, 500);
      },
      disabled:
        invalid ||
        submitting ||
        formSubmitting ||
        Object.keys(values).length === 0 ||
        !canSubmit,
    };

    return (
      <Fragment>
        <div className="buttons margin-top-5 form-actions">
          <div>
            {renderActionButton(
              "Save & Quit",
              quit,
              "cancel",
              tablePagesErrors
            )}
          </div>
          <div>
            {page > 0 &&
              renderSaveButton(
                mutation,
                values,
                dataprop_name,
                application_id,
                cleanData,
                history,
                "Back",
                "outline",
                previous,
                form_ui,
                form_ui_name,
                tablePagesErrors // 12
              )}
            {!isLastPage ? (
              renderSaveButton(
                mutation,
                values,
                dataprop_name,
                application_id,
                cleanData,
                history,
                "Continue",
                "blue",
                next,
                form_ui,
                form_ui_name,
                tablePagesErrors,
                isLocked
              )
            ) : (
              <>
                {hasSubmitConfirmation ? (
                  <SubmitConfirmationModal
                    onClick={(e) => submitButton.onClick(e)}
                    disabled={submitButton.disabled}
                  />
                ) : (
                  <Button
                    type="submit"
                    coloring="green"
                    onClick={(e) => submitButton.onClick(e)}
                    disabled={submitButton.disabled}
                  >
                    Submit
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
        <div style={modalInnerShell}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://flag.dol.gov/support/FAQ"
          >
            <div className="help-link" style={getHelpLink}>
              <span>Have a question? </span>
              <span style={helpHref}>Get Help</span>
            </div>
          </a>
        </div>
      </Fragment>
    );
  };

export default renderFormActions;
